import { render, staticRenderFns } from "./ContactAvatar.vue?vue&type=template&id=4b256618&scoped=true"
import script from "./ContactAvatar.vue?vue&type=script&lang=js"
export * from "./ContactAvatar.vue?vue&type=script&lang=js"
import style0 from "./ContactAvatar.vue?vue&type=style&index=0&id=4b256618&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b256618",
  null
  
)

export default component.exports